import React from 'react';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  type?: 'info' | 'warning' | 'important' | 'preview' | 'success';
  children: React.ReactNode;
};

/**
 * 補足情報・注意事項・重要情報・予告・成功のボックス
 */
const WorkflowInfoBox: React.FC<Props> = ({ type = 'info', children }) => {
  const config = {
    info: {
      color: 'info.main',
      icon: <InfoOutlinedIcon sx={{ fontSize: 20, color: 'info.main', mt: 0.2 }} />,
    },
    warning: {
      color: 'warning.main',
      icon: <WarningAmberIcon sx={{ fontSize: 20, color: 'warning.main', mt: 0.2 }} />,
    },
    important: {
      color: 'error.main',
      icon: <ErrorOutlineIcon sx={{ fontSize: 20, color: 'error.main', mt: 0.2 }} />,
    },
    preview: {
      color: '#7b1fa2',
      icon: <NavigateNextIcon sx={{ fontSize: 20, color: '#7b1fa2', mt: 0.2 }} />,
    },
    success: {
      color: 'success.main',
      icon: <CheckCircleOutlineIcon sx={{ fontSize: 20, color: 'success.main', mt: 0.2 }} />,
    },
  };

  const { color, icon } = config[type];

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderLeft: 3,
        borderLeftColor: color,
        borderRadius: 2,
        p: 2,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="flex-start">
        {icon}
        <Typography
          variant="body2"
          color="text.secondary"
          component="div"
          sx={{ mb: 1.5, lineHeight: 1.6 }}
        >
          {children}
        </Typography>
      </Stack>
    </Box>
  );
};

export default WorkflowInfoBox;
